import SidePanel from '../../../components/side-panel/SidePanel';
import { useSearchParams } from 'react-router-dom';
import WorkpaperProcedureDetailsContainer from './WorkpaperProcedureDetailsContainer';
import WorkpaperProceduresNotes from './WorkpaperProceduresNotes';

export default function AddonsSidebar(): JSX.Element {
    const [query, setQuery] = useSearchParams();
    const addon = query.get('addon');
    const focusedProcedureId = query.get('activeProcedure');

    function handleOnClose(): void {
        setQuery((prev) => {
            prev.delete('addon');
            prev.delete('activeProcedure');
            return prev;
        });
    }

    return (
        <SidePanel onClose={handleOnClose} isOpen={addon !== null}>
            <div>
                {addon === 'procedureDetails' && focusedProcedureId !== null && (
                    <WorkpaperProcedureDetailsContainer focusedProcedureId={focusedProcedureId} />
                )}
                {addon === 'notes' && <WorkpaperProceduresNotes />}
            </div>
        </SidePanel>
    );
}
